import { formatRating } from '../../utils/rating';
import SettingsNavItems from '../../settings/SettingsNavItems';
import StorageNavItem from '../../storage/StorageNavItem';
import { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { Avatar, Box, Button, Chip, Divider, Drawer, IconButton, List, ListItem, ListItemButton,
    ListItemContent, ListItemDecorator, Sheet, Stack, Tooltip, Typography } from '@mui/joy';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { LayoutContext } from '../../context';
import { clearAuthToken } from '../../auth';
import SwitchRoleButton from './SwitchRoleButton';

export default function SidebarQuality() {
    const { account, sidebarOpen, setSidebarOpen, setAccount, setLock,
        setTokenEmployee, setModalProfile } = useContext(LayoutContext);
    const navigate = useNavigate();
    const qualityActive = useLocation().pathname.startsWith('/quality');
    const close = () => setSidebarOpen(false);
    const rating = Number(account?.reviews?.statistics?.average_rating);
    const logout = () => {
        clearAuthToken();
        try { localStorage.removeItem('active_role'); } catch { /* Storage отключён. */ }
        setAccount({}); setTokenEmployee(null); setLock(true); close();
    };
    const content = <Sheet sx={{ height: '100%', minHeight: 0, p: 2, display: 'flex', flexDirection: 'column' }}>
        <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
            <Stack direction="row" spacing={1} sx={{ p: 0.5, alignItems: 'center' }}>
                <img src="/logo191.jpg" alt="" width="30" height="30" />
                <Typography level="title-md">PLANIUM</Typography>
            </Stack>
            <IconButton size="sm" variant="plain" onClick={close} aria-label="Закрыть меню" sx={{ display: { md: 'none' } }}>
                <CloseRoundedIcon />
            </IconButton>
        </Stack>
        <Box component="nav" aria-label="Кабинет качества" sx={{ mt: 2, flex: 1, minHeight: 0, overflowY: 'auto' }}>
            <List size="sm" sx={{ '--ListItem-paddingY': '0.5rem', '--List-gap': '10px' }}>
                        <StorageNavItem />
                    <SettingsNavItems />
                <ListItem>
                    <ListItemButton variant={qualityActive ? "soft" : "plain"} color={qualityActive ? "primary" : "neutral"} aria-current={qualityActive ? "page" : undefined}
                        sx={{ lineHeight: 1.1, px: 2, borderRadius: 'lg' }}
                        onClick={() => { navigate('/quality'); close(); }}>
                        <ListItemDecorator><FactCheckRoundedIcon /></ListItemDecorator>
                        <ListItemContent>Контроль качества</ListItemContent>
                        <KeyboardArrowRightRoundedIcon />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
        <Divider sx={{ mb: 1 }} />
        <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center', flexShrink: 0, minWidth: 0 }}>
            <Box component="button" onClick={() => { setModalProfile(true); close(); }}
                aria-label="Открыть профиль" sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1,
                    minWidth: 0, p: 1, border: 0, background: 'transparent', textAlign: 'left',
                    cursor: 'pointer', borderRadius: 'lg', '&:hover': { bgcolor: 'neutral.softBg' } }}>
                <Avatar variant="outlined" size="sm" src="/smile.png" sx={{ p: 0.3, '& > img': { width: 25, height: 'auto' } }} />
                <Stack spacing={0.5} sx={{ minWidth: 0 }}>
                    <Chip size="sm" variant="soft" color="primary" endDecorator={<StarRoundedIcon sx={{ color: '#e8d221' }} />}>
                        Рейтинг: {account?.reviews?.statistics?.average_rating != null && Number.isFinite(rating) ? formatRating(rating) : '—'}
                    </Chip>
                    <Typography level="title-sm" noWrap sx={{ lineHeight: 1.1 }}>{account?.last_name} {account?.name}</Typography>
                    <Typography level="body-xs" noWrap sx={{ lineHeight: 1.1 }}>{account?.email}</Typography>
                </Stack>
            </Box>
            <Stack spacing={0.5}>
                <SwitchRoleButton />
                <Tooltip title="Выйти"><IconButton size="sm" variant="soft" color="danger" aria-label="Выйти" onClick={logout}>
                    <ExitToAppRoundedIcon />
                </IconButton></Tooltip>
            </Stack>
        </Stack>
    </Sheet>;
    return <>
        <Box sx={{ width: 240, flexShrink: 0, height: '100dvh', display: { xs: 'none', md: 'block' },
            borderRight: '1px solid', borderColor: 'divider' }}>{content}</Box>
        <Drawer open={sidebarOpen} onClose={close} sx={{ display: { md: 'none' }, zIndex: 10100 }}
            slotProps={{ content: { sx: { width: 240, maxWidth: '90vw' } } }}>{content}</Drawer>
    </>;
}